import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import Modal from 'components/ModalSecond';
import { SizedLongBody } from 'containers/LoginPage/styles';
import { injectIntl, useIntl } from 'react-intl';
import { StoreContext } from 'utils/contextStore';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { closeModalPAC } from 'store/global/actions';
import { AssuranceIcon } from 'images';
import { useMediaQuery } from '@material-ui/core';
import DesktopFooter from 'components/FooterModal/desktopFooter';
import MobileFooter from 'components/FooterModal/mobileFooter';
import {
  sendPacInfos,
  setCategoryParamPAC,
  setOrganismesPAC,
  setPacResponse,
  updatePACObject,
} from '../../store/pac/actions';

/* istanbul ignore next */
export const initialValues = {
  organisme: '',
  category: '',
  nom: '',
  prenom: '',
  genre: '',
  dateNaissance: null,
  listFiles: [],
};

const ModalPAC = ({ isOpen, openModalPAC, ...props }: any) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { PACProcessStepsState, isLoadingParamsState } = React.useContext(
    StoreContext,
  );
  const getStep = PACProcessStepsState?.PACProcessStep;
  const setStep = PACProcessStepsState?.setPACProcessStep;
  const isLoadingParams = isLoadingParamsState?.isLoadingParams;
  const isNotMobile = useMediaQuery('(min-width:960px)');
  const pacObject = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'pacObject']),
  );
  const pacOrganismes = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'pacOrganismes']),
  );
  const isLoadingPACResponse = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'isLoadingPACResponse']),
  );

  const responsePAC = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'responsePAC']),
  );

  /* istanbul ignore next */
  const resetPACInformations = () => {
    dispatch(setOrganismesPAC(null));
    dispatch(setCategoryParamPAC(null));
    dispatch(updatePACObject({ TmpListFiles: [] }));
  };

  /* istanbul ignore next */
  const getMobileTitleStepper = (getStep: number) => {
    switch (getStep) {
      case 0:
        return (
          '1/5 - ' +
          intl.formatMessage({
            id: 'Home_text_Health_declarer_une_personne_identite_step',
          })
        );
      case 1:
        return (
          '2/5 - ' +
          intl.formatMessage({
            id: 'Home_text_Health_declarer_une_personne_step1',
          })
        );
      case 2:
        return (
          '3/5 - ' +
          intl.formatMessage({
            id: 'Home_text_Health_declarer_une_personne_step2',
          })
        );
      case 3:
        return (
          '4/5 - ' +
          intl.formatMessage({
            id: 'Home_text_Health_declarer_une_personne_step3',
          })
        );
      case 4:
        return (
          '5/5 - ' +
          intl.formatMessage({
            id: 'Home_text_Health_declarer_une_personne_step4',
          })
        );
      default:
        break;
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={
        getStep === 0
          ? ProcessSchema0(intl)
          : getStep === 1
          ? ProcessSchema1(intl)
          : getStep === 2
          ? ProcessSchema2(pacOrganismes, pacObject, intl)
          : ProcessSchema3(intl)
      }
      onSubmit={
        /* istanbul ignore next */
        (values, actions) => {
          if (getStep === 4) {
            dispatch(sendPacInfos());
            resetPACInformations();
          }
          setStep(getStep + 1);
        }
      }
    >
      {(FormikProps) => (
        <Modal
          open={isOpen}
          handleOpen={openModalPAC}
          handleClose={
            /* istanbul ignore next */ () => {
              FormikProps.resetForm({ values: initialValues });
              setStep(0);
              dispatch(setPacResponse(null));
              dispatch(closeModalPAC());
            }
          }
          header={
            isNotMobile ? (
              <>
                <SizedLongBody weight="500" color="#FAFAFA">
                  {intl.formatMessage({
                    id: 'Home_text_Health_declarer_une_personne',
                  })}
                </SizedLongBody>
              </>
            ) : (
              <>
                <img
                  alt=""
                  src={AssuranceIcon.Back}
                  onClick={
                    /* istanbul ignore next */ () =>
                      getStep !== 0 &&
                      responsePAC === null &&
                      setStep(getStep - 1)
                  }
                />
                <div style={{ flexDirection: 'column', textAlign: 'center' }}>
                  <SizedLongBody weight="500" color="#FAFAFA">
                    {intl.formatMessage({
                      id: 'Home_text_Health_declarer_une_personne',
                    })}
                  </SizedLongBody>
                  <SizedLongBody weight="500" color="#FAFAFA">
                    {getMobileTitleStepper(getStep)}
                  </SizedLongBody>
                </div>
              </>
            )
          }
          content={props.content}
          footer={
            responsePAC === null ? (
              isNotMobile ? (
                <DesktopFooter
                  isLoading={isLoadingPACResponse}
                  isLoadingParams={isLoadingParams}
                  setStep={setStep}
                  getStep={getStep}
                />
              ) : (
                <MobileFooter
                  isLoadingParams={isLoadingParams}
                  isLoading={isLoadingPACResponse}
                  getStep={getStep}
                />
              )
            ) : (
              <></>
            )
          }
        />
      )}
    </Formik>
  );
};

/* istanbul ignore next */
const getPoliceAgeLimit = (pacOrganismes: any, policyNumber: any) => {
  return pacOrganismes?.find((elem: any) => elem.NUM_POLICE === policyNumber)
    ?.AGE_LIMITE_PAC;
};

/* istanbul ignore next */
const calculateAge = (dateNaissance: any) => {
  return Math.abs(
    moment().diff(moment(dateNaissance, 'DD/MM/YYYY', true), 'years'),
  );
};

const ProcessSchema0 = (intl: any) => {
  /* istanbul ignore next */
  return Yup.object().shape({
    organisme: Yup.string().required(
      intl.formatMessage({ id: 'required.field' }),
    ),
  });
};
const ProcessSchema1 = (intl: any) => {
  /* istanbul ignore next */
  return Yup.object().shape({
    category: Yup.string().required(
      intl.formatMessage({ id: 'required.field' }),
    ),
  });
};
const ProcessSchema2 = (pacOrganismes: any, pacObject: any, intl: any) => {
  /* istanbul ignore next */
  return Yup.object().shape({
    nom: Yup.string().required(intl.formatMessage({ id: 'required.field' })),
    prenom: Yup.string().required(intl.formatMessage({ id: 'required.field' })),
    genre: Yup.string().required(intl.formatMessage({ id: 'required.field' })),
    dateNaissance: Yup.date()
      .typeError(intl.formatMessage({ id: 'Input.Error.Date' }))
      .test(
        'Age is Valid',
        intl.formatMessage({ id: 'PAC_Input_Date_Error_AgeLimit' }),
        /* istanbul ignore next */
        (value) => {
          if (pacObject.category.label.toLowerCase() === 'enfant')
            return (
              calculateAge(value) <
              getPoliceAgeLimit(pacOrganismes, pacObject.numPolice)
            );
          return true;
        },
      )
      .test(
        'date <= date actuelle',
        intl.formatMessage({ id: 'PAC.Input.Error.Date' }),
        (value) => {
          /* istanbul ignore next */
          const selectedDate = moment(value, 'DD/MM/YYYY', true);
          /* istanbul ignore next */
          const diffDate = moment().diff(selectedDate, 'days', true);
          /* istanbul ignore next */
          return selectedDate.isValid() && diffDate > 0;
        },
      )
      .required(intl.formatMessage({ id: 'required.field' }))
      .nullable(),
  });
};
const ProcessSchema3 = (intl: any) => {
  /* istanbul ignore next */
  return Yup.object().shape({
    listFiles: Yup.array()
      .required(intl.formatMessage({ id: 'required.field' }))
      .min(1)
      .max(10),
  });
};
export default injectIntl(ModalPAC);
